import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { PreloaderContextProvider } from '@flicent/fieldpulse-react-component-library-frontend';

import App from './App';

import './index.css';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <BrowserRouter>
    <PreloaderContextProvider>
      <App/>
    </PreloaderContextProvider>
  </BrowserRouter>
);